<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item active>General Codes</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">General Codes</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row">
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Entity</label>
                                <input
                                        class="form-control"
                                        placeholder="Entity Name"
                                        v-model="filterOptions.entity"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Short Description</label>
                                <input
                                        class="form-control"
                                        placeholder="Short Description"
                                        v-model="filterOptions.shortDescription"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Code</label>
                                <input
                                        class="form-control"
                                        placeholder="Code"
                                        v-model="filterOptions.code"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Grouping Code</label>
                                <input
                                        class="form-control"
                                        placeholder="Grouping Code"
                                        v-model="filterOptions.groupingCode"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>

                <div class="d-print-none dropdown mb-3 text-right">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown" style="width: 100px" type="button">
                        <span>Actions</span>
                    </button>
                    <div class="dropdown-menu">
                        <RouterLink :to="{name: 'AddGeneralCode'}" class="btn btn-outline-light dropdown-item text-left"
                                    title="Add new General Code">
                            <i class="fa fa-plus"></i>Add
                        </RouterLink>
                    </div>
                </div>

                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="generalCodes"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                        <router-link :to="{name:'GeneralCodeDetails',params:{id:row.item.id,entity:row.item.entity}}"
                                     class="btn btn-sm btn-warning d-print-none"
                                     data-toggle="tooltip"
                                     title="Edit general code details">
                            <i class="fa fa-pencil-alt"></i>Edit
                        </router-link>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalGeneralCodes"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>

            </div>
        </div>

    </div>
</template>

<script>
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import GeneralCodeService from "@/services/GeneralCodeService";

    export default {
        components: {
            AppFormCardCollapsable,
            AppTablePagination,
        },
        data() {
            return {
                generalCodes: [],
                totalGeneralCodes: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    entity: null,
                    shortDescription: null,
                    code: null,
                    groupingCode: null,
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:100px'
                    }, {
                        key: 'entity',
                        label: 'Entity',
                    },
                    {
                        key: 'code',
                        label: 'Code',
                    },
                    {
                        key: 'shortDescription',
                        label: 'Short Description',
                    },
                    {
                        key: 'longDescription',
                        label: 'Long Description',
                    },
                    {
                        key: 'groupingCode',
                        label: 'Grouping Code',
                    },
                ]
            }
        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                GeneralCodeService.getGeneralCodeList(vm.filterOptions)
                    .then(response => {
                        vm.generalCodes = response.data;
                        vm.totalGeneralCodes = response.totalCount;
                    }).catch(() => {
                    vm.redirectToError()
                }).finally(() => {
                    vm.isLoading = false;
                })
            },

            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
